export const provinces = [
    {
        key: "001",
        value: "آذربايجان شرقي",
        id: "ash"
    },
    {
        key: "002",
        value: "آذربايجان غربي",
        id: "agh"
    },
    {
        key: "003",
        value: "اردبيل",
        id: "ard"
    },
    {
        key: "004",
        value: "اصفهان",
        id: "esf"
    },
    {
        key: "005",
        value: "البرز",
        id: "alb"
    },
    {
        key: "006",
        value: "ايلام",
        id: "ilm"
    },
    {
        key: "007",
        value: "بوشهر",
        id: "bhr"
    },
    {
        key: "008",
        value: "تهران",
        id: "teh"
    },
    {
        key: "009",
        value: "چهارمحال بختياري",
        id: "chr"
    },
    {
        key: "010",
        value: "خراسان جنوبي",
        id: "khj"
    },
    {
        key: "011",
        value: "خراسان رضوي",
        id: "khr"
    },
    {
        key: "012",
        value: "خراسان شمالی",
        id: "xsh"
    },
    {
        key: "013",
        value: "خوزستان",
        id: "khz"
    },
    {
        key: "014",
        value: "زنجان",
        id: "znj"
    },
    {
        key: "015",
        value: "سمنان",
        id: "smn"
    },
    {
        key: "016",
        value: "سيستان و بلوچستان",
        id: "sys"
    },
    {
        key: "017",
        value: "فارس",
        id: "frs"
    },
    {
        key: "018",
        value: "قزوين",
        id: "qzv"
    },
    {
        key: "019",
        value: "قم",
        id: "qom"
    },
    {
        key: "020",
        value: "كردستان",
        id: "krd"
    },
    {
        key: "021",
        value: "كرمان",
        id: "krm"
    },
    {
        key: "022",
        value: "كرمانشاه",
        id: "ksh"
    },
    {
        key: "031",
        value: "کهگیلویه و بویراحمد",
        id: "byr"
    },
    {
        key: "023",
        value: "گلستان",
        id: "gol"
    },
    {
        key: "024",
        value: "گيلان",
        id: "gil"
    },
    {
        key: "025",
        value: "لرستان",
        id: "lor"
    },
    {
        key: "026",
        value: "مازندران",
        id: "mzn"
    },
    {
        key: "027",
        value: "مركزي",
        id: "mrk"
    },
    {
        key: "028",
        value: "هرمزگان",
        id: "hrm"
    },
    {
        key: "029",
        value: "همدان",
        id: "hmd"
    },
    {
        key: "030",
        value: "یزد",
        id: "yzd"
    },
]

export const fullCities = {
    ash: [
        "اسكو",
        "اهر",
        "ایلخچی",
        "باسمنج",
        "بستان آباد",
        "بناب",
        "تبريز",
        "تسوج",
        "جلفا",
        "خسروشهر",
        "سراب",
        "سهند",
        "شبستر",
        "صوفیان",
        "مراغه",
        "مرند",
        "ملكان",
        "ممقان",
        "ميانه",
        "هاديشهر",
        "هريس",
        "هشترود",
        "ورزقان"
    ],
    agh: [
        "اروميه",
        "اشنويه",
        "بوكان",
        "تكاب",
        "خوي",
        "سر دشت",
        "سلماس",
        "شاهين دژ",
        "ماكو",
        "مهاباد",
        "مياندوآب",
        "نقده",
        "پلدشت",
        "شوط",
        "پيرانشهر",
        "چالدران",
        "چایپاره"
    ],
    ard: [
        "اردبيل",
        "خلخال",
        "مشگين شهر",
        "نمين",
        "نير",
        "بیله‌سوار",
        "کوثر",
        "سرعین",
        "پارس آباد",
        "گرمي"
    ],
    esf: [
        "آران و بيدگل",
        "اردستان",
        "اصفهان",
        "باغ بهادران",
        "برخوار",
        "بوئین و میاندشت",
        "تودشک",
        "تيران",
        "چادگان",
        "حاجي آباد",
        "خميني شهر",
        "خوانسار",
        "خور و بیابانک",
        "درچه",
        "دهاقان",
        "زرين شهر",
        "سميرم",
        "شهرضا",
        "شاهین‌شهر و میمه",
        "عسگران",
        "علويجه",
        "فلاورجان",
        "فریدن",
        "فریدون‌شهر",
        "كاشان",
        "گلپایگان",
        "لنجان",
        "مباركه",
        "نائین",
        "نجف آباد",
        "نطنز",
        "ورزنه",
        "کوهپایه",
        "گلپايگان"
    ],
    alb: [
        "اشتهارد",
        "ساوجبلاغ",
        "طالقان",
        "فردیس",
        "كرج",
        "ماهدشت",
        "نظرآباد",
        "هشتگرد"
    ],
    ilm: [
        "آبدانان",
        "ايلام",
        "ايوان",
        "بدره",
        "چرداول",
        "دره شهر",
        "دهلران",
        "سرابله",
        "سیروان",
        "ملکشاهی",
        "مهران"
    ],
    bhr: [
        "اهرم",
        "برازجان",
        "بوشهر",
        "تنگستان",
        "جم",
        "خورموج",
        "دشتستان",
        "دشتی",
        "دير",
        "دیلم",
        "عسلویه",
        "كنگان",
        "کاکی",
        "گناوه"
    ],
    teh: [
        "اسلامشهر",
        "باقرشهر",
        "بهارستان",
        "بومهن",
        "پاکدشت",
        "پردیس",
        "پیشوا",
        "تجريش",
        "تهران",
        "دماوند",
        "رباط كريم",
        "رودهن",
        "ري",
        "شريف آباد",
        "شمیرانات",
        "شهريار",
        "فشم",
        "فيروزكوه",
        "قدس",
        "قرچك",
        "كهريزك",
        "لواسان",
        "ملارد",
        "ورامين",
        "پاكدشت",
        "چهاردانگه"
    ],
    chr: [
        "اردل",
        "بن",
        "بروجن",
        "سامان",
        "شهركرد",
        "فارسان",
        "کوهرنگ",
        "کیار",
        "لردگان",
        "چلگرد"
    ],
    khj: [
        "بيرجند",
        "بشرویه",
        "خوسف",
        "درمیان",
        "زیرکوه",
        "سرایان",
        "سربيشه",
        "طبس",
        "فردوس",
        "قائن",
        "نهبندان"
    ],
    khr: [
        "باخرز",
        "بجستان",
        "بردسکن",
        "بینالود",
        "تايباد",
        "تربت جام",
        "تربت حيدريه",
        "جوین",
        "جغتای",
        "چناران",
        "خلیل‌آباد",
        "خواف",
        "خوشاب",
        "داورزن",
        "درگز",
        "رشتخوار",
        "زاوه",
        "سبزوار",
        "سرخس",
        "طبس",
        "طرقبه",
        "فريمان",
        "فیروزه",
        "قوچان",
        "كاشمر",
        "کلات",
        "مشهد",
        "مه‌ولات",
        "نيشابور",
        "چناران",
        "گناباد"
    ],
    xsh: [
        "اسفراين",
        "بجنورد",
        "جاجرم",
        "راز و جرگلان",
        "شيروان",
        "فاروج",
        "گرمه",
        "مانه و سملقان"
    ],
    khz: [
        "آبادان",
        "آغاجاری",
        "امیدیه",
        "اندیکا",
        "انديمشك",
        "اهواز",
        "ايذه",
        "ايرانشهر",
        "باغ ملك",
        "باوی",
        "بندر امام خميني",
        "بندر ماهشهر",
        "بهبهان",
        "حمیدیه",
        "خرمشهر",
        "دزفول",
        "دشت آزادگان",
        "رامشیر",
        "رامهرمز",
        "سوسنگرد",
        "شادگان",
        "شوش",
        "شوشتر",
        "کارون",
        "گتوند",
        "لالي",
        "مسجد سليمان",
        "ملاثانی",
        "هفتکل",
        "هنديجان",
        "هويزه"
    ],
    znj: [
        "آب بر",
        "ابهر",
        "ایجرود",
        "خدابنده",
        "خرمدره",
        "زنجان",
        "سلطانیه",
        "طارم",
        "قيدار",
        "ماهنشان"
    ],
    smn: [
        "آرادان",
        "ايوانكي",
        "بسطام",
        "دامغان",
        "سرخه",
        "سمنان",
        "شاهرود",
        "گرمسار",
        "مهدی‌شهر",
        "میامی"
    ],
    sys: [
        "ايرانشهر",
        "چابهار",
        "خاش",
        "دلگان",
        "راسک",
        "زابل",
        "زاهدان",
        "زهک",
        "سراوان",
        "سرباز",
        "سیب و سوران",
        "فنوج",
        "قصرقند",
        "کنارک",
        "مهرستان",
        "ميرجاوه",
        "نیک شهر",
        "نیمروز",
        "هامون",
        "هیرمند",
    ],
    frs: [
        "آباده",
        "اردكان",
        "ارسنجان",
        "استهبان",
        "اقليد",
        "بوانات",
        "پاسارگاد",
        "جهرم",
        "حاجي آباد",
        "خرامه",
        "خرم‌بید",
        "خنج",
        "داراب",
        "رستم",
        "زرقان",
        "زرین‌دشت",
        "سروستان",
        "سوريان",
        "سپيدان",
        "شيراز",
        "صفاشهر",
        "فراشبند",
        "فسا",
        "فيروز آباد",
        "قیر و کارزین",
        "كازرون",
        "گراش",
        "لار",
        "لامرد",
        "مرودشت",
        "ممسنی",
        "مهر",
        "کوار",
        "نی ریز",
    ],
    qzv: [
        "آبيك", "بوئين زهرا", "تاكستان", "قزوين"
    ],
    qom: [
        "قم"
    ],
    krd: [
        "بانه", "بيجار", "حسن آباد", "سقز", "سنندج", "صلوات آباد", "قروه", "مريوان"
    ],
    krm: [
        "انار", "بافت", "بردسير", "بم", "جيرفت", "راور", "رفسنجان", "زرند", "سيرجان", "كرمان", "كهنوج", "کوهبنان"
    ],
    ksh: [
        "اسلام آباد غرب", "جوانرود", "سنقر", "صحنه", "قصر شيرين", "كرمانشاه", "كنگاور", "هرسين", "پاوه"
    ],
    byr: [
        "اسلام آباد غرب", "جوانرود", "سنقر", "صحنه", "قصر شيرين", "كرمانشاه", "كنگاور", "هرسين", "پاوه"
    ],
    gol: [
        "آزاد شهر", "آق قلا", "راميان", "علي آباد كتول", "كردكوی", "كلاله", "گرگان", "گنبد كاووس"
    ],
    gil: [
        "آستارا", "املش", "تالش", "رشت", "رودبار", "شفت", "صومعه سرا", "فومن", "لاهیجان", "لنگرود", "ماسال", "ماسوله", "منجيل", "هشتپر"
    ],
    lor: [
        "ازنا", "الشتر", "اليگودرز", "بروجرد", "خرم آباد", "دزفول", "دورود", "كوهدشت", "ماهشهر", "نور آباد"
    ],
    man: [
        "آمل", "بابل", "بابلسر", "بلده", "بهشهر", "تنكابن", "جويبار", "رامسر", "ساري", "قائم شهر", "محمود آباد", "نكا", "نور", "نوشهر", "چالوس"
    ],
    mrk: [
        "آشتيان", "اراك", "تفرش", "خمين", "دليجان", "ساوه", "شازند", "محلات"
    ],
    hrm: [
        "بستك", "بندر جاسك", "بندر خمیر", "بندر لنگه", "بندرعباس", "حاجي آباد", "دهبارز", "قشم", "قشم", "كيش", "ميناب"
    ],
    hmd: [
        "اسدآباد", "بهار", "رزن", "ملاير", "نهاوند", "همدان"
    ],
    yzd: [
        "ابركوه", "اردكان", "اشكذر", "بافق", "تفت", "خضرآباد", "زارچ", "طبس", "مهريز", "ميبد", "هرات", "يزد"
    ],
}